const Warning: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.547 15.9134V17.3764H11.447V15.9134H12.547Z" fill="#EB7400" />
    <path
      d="M12.558 9.56641L12.437 15.0664H11.568L11.436 9.56641H12.558Z"
      fill="#EB7400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8062 19.7091L13.425 2.80606C13.1255 2.26667 12.5816 2 12.0438 2C11.4999 2 10.9621 2.26667 10.6626 2.8L1.19586 19.703C0.621381 20.7333 1.37921 22 2.57706 22H21.4188C22.6167 22 23.3745 20.7394 22.8062 19.7091ZM11.5346 3.28944C11.6406 3.10088 11.8264 3 12.0438 3C12.2556 3 12.4449 3.10092 12.5506 3.29133L21.9306 20.1921L21.931 20.193C22.1182 20.5338 21.8815 21 21.4188 21H2.57706C2.11758 21 1.87897 20.5326 2.06885 20.1908L11.5346 3.28944Z"
      fill="#EB7400"
    />
  </svg>
);

export default Warning;
